import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function PayMentGetway() {
  const navigate = useNavigate();
  const [errors, Seterrors] = useState("");
  const [Action, SetAction] = useState("AddPayMentGetway");
  const [Inputs, setInputs] = useState([]);


  console.log(Inputs);
  //---------ShowModal----------------------------
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [
    {
      AdminName: "",
      AdminID: "",
    },
  ];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Data, SetData] = useState([]);
  useEffect(() => {
    GetData();
  }, []);
  //-------------------------------------------------------------
  async function GetData() {
    try {
      const post = {
        Action: "GetPayMentGetway",
      };
      const response = await fetch(ApiAdmin + "/PaymentGetway.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
      SetData(data);
      setInputs(data);
    } catch (error) {
      return error;
    }
  }
  //-------------------------------------------------------------
  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //--------------------------------
  const handleDubelClick = (e) => {
    const name = e.target.name;
    const value = "";
    // setInputs((values) => ({ ...values, [name]: value }));
  };
  //----------------------

  const handleSubmit = async (e) => {
    e.preventDefault();
    //====================================
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());


    if (window.confirm("هل تريد الحفظ   ")) {
      try {
        const response = await fetch(ApiAdmin + "/PaymentGetway.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });

        const data = await response.json();
        console.log(data);
        if (data.errors != "") {
          Seterrors(data.errors);
          handleShowModal();
        }
        if (data.msg != "") {
          Seterrors(data.msg);
          handleShowModal();
          // GetData();
          // e.target.reset();
        }
        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };


  return (
    <>
      <Header_ />
      <form method="POST" onSubmit={handleSubmit}>
        <div
          dir="rtl"
          className="row p-0 mt-0 text-end m-auto  bg-white mt-lg-4 mt-md-4"
          style={{ maxWidth: "1000px" }}
        >
          <h3 className="text-orange fw-bold py-1 mt-2">
            <Link to="../admin/Setting">
              <i className="fa-solid fa-chevron-right text-orange bg-light p-1 mx-2 fs-4"></i>
            </Link>
            {" Payment Getway"}
          </h3>

          <input type="hidden" name="Action" value={Action} />
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              Gateway Name
            </label>
            <input
              type="text"
              name="gateway_name"
              className="form-control"
              autoComplete="off"
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.gateway_name}
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              Api Key
            </label>
            <input
              type="text"
              name="api_key"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.api_key}
            />
          </div>
          <div className="col-lg-12 col-12">
            <label className="col-form-label"> Secret Key</label>
            <input
              type="text"
              name="secret_key"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.secret_key}
            />
          </div>
          <div className="col-lg-12 col-12">
            <label className="col-form-label">  Public Key</label>
            <input
              type="text"
              name="public_key"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.public_key}
            />
          </div>
          <div className="col-lg-12 col-12">
            <label className="col-form-label" autoComplete="off">
              hmac secret
            </label>
            <input
              type="text"
              name="hmac_secret"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.hmac_secret}
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              integration_id_wallet
            </label>
            <input
              type="text"
              name="integration_id_wallet"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.integration_id_wallet}
            />
          </div>
          <div className="col-lg-12 col-12">
            <label className="col-form-label" autoComplete="off">
              integration_id_card
            </label>
            <input
              type="text"
              name="integration_id_card"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.integration_id_card}
            />
          </div>

          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              iframe_id
            </label>
            <input
              type="text"
              name="iframe_id"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.iframe_id}
            />
          </div>

          <div className="col-lg-2 col-4">
            <label className="col-form-label" autoComplete="off">
              Tax
            </label>
            <input
              type="text"
              name="tax"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.tax}
            />
          </div>

          <div className="col-lg-2 col-4">
            <label className="col-form-label" autoComplete="off">
              Omowla
            </label>
            <input
              type="text"
              name="omowla"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.omowla}
            />
          </div>
          <div className="col-12 mt-4 text-center">
            <button className="btn btn-success px-4 w-50">SAVE</button>
          </div>
          <br />
          <br />
          <br />
          <br />
        </div>
      </form>
      <MSG />
    </>
  );

  function MSG() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 text-center">
                <h4 className="text-start p-0 m-0">خطا </h4>
                <hr />
                <h5 className=" text-center ">{errors}</h5>
                <button
                  onClick={() => handleCloseModal()}
                  className="btn btn-danger w-50 m-3"
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
